module.exports = __webpack_public_path__ + "static/media/logo-light.0a4fa34e.svg";